import React, { useState, useMemo, useEffect, useCallback } from 'react'
import Button from 'react-bootstrap/esm/Button'
import ReactPlaceholder from 'react-placeholder/lib'
import Controllers from '../../Api/Controllers'
import { Input, FormCustom, TextArea, Select, CheckBox } from '../../Components/Form/Form'
import Helpers from '../../Components/Helpers/Helpers'
import ProductList from '../Product/ProductList'
import { toast } from 'react-toastify';

const DOC_TYPES_WITH_LOTS = [1, 2, 3];

const DocumentForm = ({ data, disablebSubmit, loadSubmit, viewSubmit, verified, submitStatus, addDetails, setLoadSubmit, setModalShow, setDataUpdated, setReload }) => {
    const [row, setRow] = useState({
        p_id_document: data.id_document,
        p_number_invoice_doc: data.number_invoice_doc,
        p_number_lot_doc: data.number_lot_doc,
        p_id_period: data.id_period,
        p_code_period: data.code_period,
        p_id_type_document: data.id_type_document,
        p_observation_doc: data.observation_doc,
        p_id_branch_office_origin: data.id_branch_office_origin,
        p_id_branch_office_destination: data.id_branch_office_destination,
        p_date_doc: data.date_doc,
        p_details: data.details,
        p_observation_materia_prima: data.observation_materia_prima,
        p_date_free_materia_prima: data.date_free_materia_prima,
        p_date_approve_production: data.date_approve_production,
        p_date_approve_recepcion: data.date_approve_recepcion,
    })

    const [ready, setReady] = useState(false)
    const [rowsTypeDocument, setRowsTypeDocument] = useState([])
    const [rowsBranchOffice, setRowsBranchOffice] = useState([])
    const [rowsLaboratory, setRowsLaboratory] = useState([])
    const [modalProducts, setModalProducts] = useState(false)

    const [loadStatus, setLoadStatus] = useState(false)
    const [enabledChecks, setEnabledChecks] = useState(true)
    const [status, setStatus] = useState({
        p_anulado: '',
        p_observation_rejected: ''
    })

    const [productProduction, setProductProduction] = useState({
        id_product: data.id_product,
        name_product: data.name_product,
        key_product: data.key_product,
        qty: data.qty_product,
    })

    const handleShowModalProducts = () => {
        if (row.p_id_branch_office_origin && !isNaN(parseInt(row.p_id_type_document))) {
            setModalProducts(true)
        } else {
            Helpers.toast.construct({ response: 'warning', message: 'Por favor, seleccionar Sucursal y Tipo de Documento', toast })
        }
    }
    const handleHideModalProducts = () => setModalProducts(false)

    const [isProduction, setIsProduction] = useState(isNaN(row.p_id_document) ? false : (parseInt(row.p_id_type_document) === 4))

    const [isMass, setIsMass] = useState(false)
    const [validateProducts, setValidateProducts] = useState(false)
    const [listProducts, setListProducts] = useState('')

    const notExistsStock = {
        exists: false,
        details: {
            message: '',
            products: []
        }
    }

    const [existsStock, setExistsStock] = useState({
        ...notExistsStock,
        exists: true
    })

    useEffect(_ => {
        setIsProduction(parseInt(row.p_id_type_document) === 4)
    }, [row.p_id_type_document])

    useEffect(() => {
        let promises = [
            Controllers.type_document.get_type_document(),
            Controllers.worker.get_worker_all_branch_office_without_laboratory(),
            Controllers.period.get_period_current(),
            Controllers.worker.get_worker_laboratory_public(),
        ]

        Promise.all(promises).then(res => {
            setRowsTypeDocument([
                ...res[0].data,
            ])
            setRowsBranchOffice(res[1].data)
            setRowsLaboratory(res[3].data)
            if (res[2].data?.id_period && data.id_document === '') {
                setRow({ ...row, p_id_period: res[2].data?.id_period, p_code_period: res[2].data?.code_period })
            }
            setReady(true)
        })
    }, [data.id_document])

    useEffect(_ => {
        let existsError = row.p_details.some(p => parseInt(p.enabled) === 0)
        if (existsError) {
            setStatus({
                ...status,
                p_anulado: 4
            })
            setEnabledChecks(false)
        } else {
            setEnabledChecks(true)
            setStatus({
                ...status,
                p_anulado: ''
            })
        }
    }, [row.p_details])

    const idTypeDocument = useMemo(() => {
        if (!row.p_id_type_document) {
            return
        }

        let finded = rowsTypeDocument.find(t => parseInt(row.p_id_type_document) === parseInt(t.id_type_document))

        if (!finded) {
            return
        }
        return {
            label: finded.name_document,
            value: finded.id_type_document
        }
    }, [row.p_id_type_document, rowsTypeDocument])

    const idBranchOfficeOrigin = useMemo(() => {
        if (!row.p_id_branch_office_origin) {
            return ''
        }

        let finded = rowsBranchOffice.find(t => parseInt(row.p_id_branch_office_origin) === parseInt(t.id_branch_office))

        if (!finded) {
            return ''
        }
        return {
            label: finded.name_branch_office,
            value: finded.id_branch_office
        }
    }, [row.p_id_branch_office_origin, rowsBranchOffice])

    const idBranchOfficeDestination = useMemo(() => {
        if (!row.p_id_branch_office_destination) {
            return ''
        }

        let rowsBo = isProduction ? rowsLaboratory : rowsBranchOffice
        let finded = rowsBo.find(t => parseInt(row.p_id_branch_office_destination) === parseInt(t.id_branch_office))

        if (!finded) {
            return ''
        }
        return {
            label: finded.name_branch_office,
            value: finded.id_branch_office
        }
    }, [row.p_id_branch_office_destination, rowsBranchOffice, rowsLaboratory, isProduction])

    const getSubtotal = useCallback(() => {
        let total = 0
        let totalPiezas = 0
        row.p_details.forEach(r => {
            let subt = parseFloat(r.qty) * parseFloat(r.price)
            if (!isNaN(parseFloat(r.qty) * parseFloat(r.price))) {
                total += subt
            }
            if (!isNaN(parseFloat(r.qty))) {
                totalPiezas += parseFloat(r.qty)
            }
        })

        let iva = total * Helpers.config.percentageIva

        return {
            total: total.toFixed(2),
            subtotal: (total - iva).toFixed(2),
            iva: iva.toFixed(2),
            totalPiezas
        }
    }, [row.p_details])

    const dataSubmit = useCallback(() => {
        return {
            ...row,
            p_details: row.p_details.map(r => {
                return {
                    p_id_product: r.id_product,
                    p_key_product: r.key_product,
                    p_name_product: r.name_product,
                    p_lot: r.lot,
                    p_price: r.price,
                    p_qty: r.qty,
                    p_qty_original: r?.qty_original,
                    p_date_expiration: r.date_expiration
                }
            }),
            p_total_doc: getSubtotal().total,
            p_subtotal_doc: getSubtotal().subtotal,
            p_iva_doc: getSubtotal().iva,
            p_id_product: productProduction?.id_product,
            p_qty_product: productProduction?.qty,
        }
    }, [row, getSubtotal, productProduction])

    const stockOut = useCallback(() => {
        return parseInt(row.p_id_type_document) === 2 || parseInt(row.p_id_type_document) === 3 || parseInt(row.p_id_type_document) === 5
    }, [row.p_id_type_document])


    const getBranchOfficeDestination = useCallback(() => {
        const findBranchOffice = rowsBranchOffice.find(b => parseInt(b.id_branch_office) === parseInt(row.p_id_branch_office_origin))
        if (!findBranchOffice) {
            return []
        }

        if (findBranchOffice.is_branch_office === 0) {
            return rowsBranchOffice.filter(b => parseInt(b.id_branch_office) !== parseInt(row.p_id_branch_office_origin) && b.is_branch_office === 0 && b.id_type_money === findBranchOffice.id_type_money)
        }

        // dev almacen general
        if (parseInt(row.p_id_type_document) === 5) {
            return rowsBranchOffice.filter(r => {
                return r.id_branch_office === (findBranchOffice.id_type_money === 1 ? 111 : 57)
            })
        }

        // traspaso
        return rowsBranchOffice.filter(r => {
            return parseInt(r.id_type_money) === findBranchOffice.id_type_money && parseInt(r.id_branch_office) !== parseInt(row.p_id_branch_office_origin) && r.is_branch_office === 1
        })
    }, [row.p_id_branch_office_origin, rowsBranchOffice, row.p_id_type_document])

    const handleInsertUpdate = ({ data }) => {
        setLoadSubmit(true)
        Controllers.document.document_insert_update(data).then(res => {
            Helpers.toast.construct({ ...res, toast })
            if (res.response === 'success') {
                setModalShow(false)
                setDataUpdated({})
            }

            setExistsStock({
                exists: res.response === 'success',
                details: {
                    message: res.message,
                    products: res.data
                }
            })

        }).catch(req => {
            Helpers.promise.catch({ req, toast })
            setExistsStock({
                exists: false,
                details: {
                    message: 'No se ha podido verificar stock.',
                    products: []
                }
            })
        })
            .finally(() => {
                setLoadSubmit(false)
                setReload(true)
            })
    }

    const totalUnit = useCallback(() => {
        if (row.p_details.length === 0) {
            return ''
        }

        if (getSubtotal().totalPiezas > 1000 && parseInt(row.p_details[0].id_product_unit) === 2) {
            return 'Kilos'
        }

        return row.p_details[0].code_product_unit
    }, [row.p_details, getSubtotal])

    const renderPiezas = useMemo(() => {
        if (parseInt(row.p_id_type_document) === 6) {
            let detailsPiezas = []
            row.p_details.forEach(r => {
                let typeUnit = '';
                let finalQty = r.qty
                typeUnit = r.code_product_unit;

                if (parseInt(r.has_conversion) === 1) {
                    if (productProduction.qty <= r.qty_conversion) {
                        finalQty = r.qty
                    } else {
                        let qty = parseFloat(finalQty) / parseFloat(r.qty_conversion)
                        if (qty > parseInt(qty)) {
                            qty = parseInt(qty) + 1
                        }
                        finalQty = qty
                    }
                } else {
                    if (parseInt(r.id_product_unit) === 2 && finalQty >= 1000) {
                        typeUnit = 'Kilos';
                    }
                    if (parseInt(r.id_product_unit) === 2 && finalQty < 1000) {
                        typeUnit = 'Kilos';
                    }
                    finalQty = parseInt(r.id_product_unit) === 2 ? parseFloat(parseFloat(!isNaN(parseInt(finalQty)) ? finalQty : 0) / 1000) : parseInt(finalQty)
                }

                let finded = detailsPiezas.find(d => d.typeUnit === typeUnit)
                if (finded) {
                    finded.qty += finalQty
                } else {
                    detailsPiezas.push({
                        typeUnit,
                        qty: finalQty
                    })
                }
            })

            return React.Children.toArray(detailsPiezas.map(d => <div className='d-flex flex-row'>
                <div className='mr-2'>{parseFloat(d.qty).toFixed(2)}</div>
                <div>{d.typeUnit}</div>
            </div>))
        } else {
            return <></>
        }
    }, [row])

    return <ReactPlaceholder rows={7} ready={ready}>
        <FormCustom id="frm_document_content" dataSubmit={dataSubmit()} onSubmit={({ data }) => {
            if (!row.p_id_period) {
                Helpers.toast.construct({ response: 'warning', message: 'No hay periodo activo. Comunicarse con el Área responsable.', toast })
                return
            }
            if (!row.p_id_type_document) {
                Helpers.toast.construct({ response: 'warning', message: 'Por favor, seleccione el Tipo de Documento.', toast })
                return
            }

            if (!row.p_id_branch_office_origin) {
                Helpers.toast.construct({ response: 'warning', message: 'Por favor, seleccione Sucursal Origen.', toast })
                return
            }

            if (row.p_details.length === 0) {
                Helpers.toast.construct({ response: 'warning', message: 'Por favor, agregar productos.', toast })
                return
            }

            if ((parseInt(row.p_id_type_document) === 3 || parseInt(row.p_id_type_document) === 5 || parseInt(row.p_id_type_document) === 6) && parseInt(row.p_id_branch_office_origin) === parseInt(row.p_id_branch_office_destination)) {
                Helpers.toast.construct({ response: 'warning', message: 'No puede realizar un traspaso de la misma sucursal', toast })
                return
            }

            if (parseInt(row.p_id_type_document) === 6) {
                if (isNaN(parseInt(productProduction.id_product))) {
                    Helpers.toast.construct({ response: 'warning', message: 'Por favor, seleccione un producto de producción.', toast })
                    return
                }
            }

            // Validación de duplicados (solo entradas/salidas/traspasos)
            if (DOC_TYPES_WITH_LOTS.includes(parseInt(row.p_id_type_document))) {
                const seen = new Set()
                for (let i = 0; i < row.p_details.length; i++) {
                    const d = row.p_details[i]
                    const key = `${d.id_product}|${(d.lot || '').toString().trim()}|${d.date_expiration || ''}`
                    if (seen.has(key)) {
                        Helpers.toast.construct({ response: 'warning', message: 'No se permiten filas con mismo producto y mismo lote.', toast })
                        return
                    }
                    seen.add(key)
                }
            }

            if (addDetails) {
                data.p_add_details = 1
            }

            return handleInsertUpdate({ data })
        }} disablebSubmit={disablebSubmit} viewSubmit={viewSubmit || addDetails} loadSubmit={loadSubmit}>
            <div className="row" id="document_header">
                {parseInt(data.anulado) === 1 && <div className='col-12 mb-4'>
                    <div>ESTADO: <strong className='text-danger'>ANULADO</strong></div>
                    <div>MOTIVO: {data.observation_anulado}</div>
                    <div>FECHA: {data.date_anulado}</div>
                    <div>USUARIO: {data.user_anulado}</div>
                </div>}
                {!isNaN(parseInt(row.p_id_document)) && <div className='col-12'>
                    Documento: <strong>{row.p_id_document}</strong>
                </div>}
                {!isNaN(parseInt(row.p_id_document)) && row?.p_observation_materia_prima && parseInt(row.p_id_type_document) === 6 && <div className='col-12'>
                    Observación Materia Prima: <strong>{row.p_observation_materia_prima}</strong>
                </div>}
                {!isNaN(parseInt(row.p_id_document)) && row?.p_date_free_materia_prima && parseInt(row.p_id_type_document) === 6 && <div className='col-12'>
                    Fecha Liberar Materia Prima: <strong>{row.p_date_free_materia_prima}</strong>
                </div>}
                {!isNaN(parseInt(row.p_id_document)) && row?.p_date_approve_production && parseInt(row.p_id_type_document) === 6 && <div className='col-12'>
                    Fecha Aprobación Producción: <strong>{row.p_date_approve_production}</strong>
                </div>}
                {!isNaN(parseInt(row.p_id_document)) && row?.p_date_approve_production && parseInt(row.p_id_type_document) === 6 && <div className='col-12'>
                    Piezas Totales Producidas: <strong>{data.qty_product_final ? data.qty_product_final : data.qty_product}</strong>
                </div>}
                {!isNaN(parseInt(row.p_id_document)) && row?.p_date_approve_recepcion && parseInt(row.p_id_type_document) === 6 && <div className='col-12'>
                    Fecha Aprobación Recepción: <strong>{row.p_date_approve_recepcion}</strong>
                </div>}
                {/* <Input
                text="Folio"
                placeholder="Folio"
                classNameParent="col-6 col-md-4 mb-2"
                icon="far fa-comment-alt"
                required
                invalid="El campo es obligatorio."
                defaultValue={data.number_invoice_doc}
                onChange={e => setRow({ ...row, p_number_invoice_doc: e.currentTarget.value })}
                maxLength={100}
            /> */}
                {/* <Input
                text="Nro Lote"
                placeholder="Nro Lote"
                classNameParent="col-6 col-md-4 mb-2"
                icon="far fa-comment-alt"
                required
                invalid="El campo es obligatorio."
                defaultValue={data.number_lot_doc}
                onChange={e => setRow({ ...row, p_number_lot_doc: e.currentTarget.value })}
                maxLength={100}
            /> */}
                <Input
                    text="Periodo"
                    placeholder="Periodo"
                    classNameParent="col-6 col-md-4 mb-2"
                    icon="far fa-comment-alt"
                    required
                    invalid="El campo es obligatorio."
                    defaultValue={row.p_code_period}
                    disabled
                    className="text-center"
                />
                <Input
                    text="Fecha"
                    placeholder="Fecha"
                    type="date"
                    classNameParent="col-6 col-md-4 mb-2"
                    icon="far fa-comment-alt"
                    required
                    invalid="El campo es obligatorio."
                    defaultValue={data.date_doc}
                    onChange={e => setRow({ ...row, p_date_doc: e.currentTarget.value })}
                    disabled={!viewSubmit}
                />
                <Select
                    classNameParent="col-6 col-md-4 mb-2"
                    icon="fas fa-percentage"
                    text="Tipo Documento"
                    options={rowsTypeDocument.map(t => {
                        return {
                            label: t.name_document,
                            value: t.id_type_document
                        }
                    })}
                    disabled={data.id_document !== ''}
                    value={idTypeDocument}
                    onChange={e => {
                        setRow({
                            ...row, p_id_type_document: e.value, p_details: [],
                            p_id_branch_office_destination: '',
                            p_id_branch_office_origin: ''
                        })
                        setProductProduction({})
                    }}
                />
                <Select
                    classNameParent="col-6 col-md-4 mb-2"
                    icon="fas fa-percentage"
                    text={isProduction ? 'Sucursal Solicitante' : 'Sucursal Origen'}
                    disabled={data.id_document !== ''}
                    options={rowsBranchOffice.filter(r => {
                        if (parseInt(row.p_id_type_document) === 6) {
                            return r.id_branch_office === 70 || r.id_branch_office === 113
                        }

                        return r;
                    }).map(t => {
                        return {
                            label: t.name_branch_office,
                            value: t.id_branch_office
                        }
                    })}
                    value={idBranchOfficeOrigin}
                    onChange={e => {
                        if (data.id_document === '') {
                            if (parseInt(e.value) !== parseInt(row.p_id_branch_office_origin)) {
                                setRow({ ...row, p_id_branch_office_origin: e.value, p_details: [], p_id_branch_office_destination: '' })
                                setProductProduction({})
                            }
                        }
                    }}
                />
                {(parseInt(row.p_id_type_document) === 3 || parseInt(row.p_id_type_document) === 5 || parseInt(row.p_id_type_document) === 4 || parseInt(row.p_id_type_document) === 6) ? <Select
                    classNameParent="col-6 col-md-4 mb-2"
                    icon="fas fa-percentage"
                    text={isProduction ? 'Laboratorio a Producir' : 'Sucursal Destino'}
                    options={(isProduction ? rowsLaboratory : getBranchOfficeDestination()).map(t => {
                        return {
                            label: t.name_branch_office,
                            value: t.id_branch_office
                        }
                    })}
                    value={idBranchOfficeDestination}
                    onChange={e => {
                        setRow({ ...row, p_id_branch_office_destination: e.value, p_details: [] })
                        setProductProduction({})
                    }}
                    disabled={data.id_document !== ''}
                /> : ''}
                {(parseInt(row.p_id_type_document) === 3 || parseInt(row.p_id_type_document) === 5) && parseInt(row.p_id_branch_office_origin) === parseInt(row.p_id_branch_office_destination) && <div className="col-12">
                    <label className='text-danger'>No puede realizar un traspaso de la misma sucursal</label>
                </div>}
                <TextArea
                    text="Comentarios"
                    placeholder="Comentarios"
                    classNameParent="col-12 mb-2"
                    icon="far fa-comment-alt"
                    required={parseInt(row.p_id_type_document) !== 3}
                    invalid="El campo es obligatorio."
                    defaultValue={data.observation_doc}
                    onChange={e => setRow({ ...row, p_observation_doc: e.currentTarget.value })}
                    rows="4"
                    disabled={!viewSubmit}
                />
                <div className="mb-2 col-12">
                    {isNaN(parseInt(row.p_id_document)) ? <Button size="sm" onClick={handleShowModalProducts}>
                        <i className="fa fa-plus mr-1"></i>Agregar Producto
                    </Button> : ''}
                    {parseInt(row.p_id_type_document) !== 6 && <>
                        {isNaN(parseInt(row.p_id_document)) ? <Button className="ml-3" size="sm" variant={isMass ? 'dark' : 'outline-dark'} onClick={_ => setIsMass(!isMass)}>Carga Masiva</Button> : ''}
                    </>}
                </div>

                {parseInt(row.p_id_type_document) === 6 && !isNaN(parseInt(productProduction.id_product)) && <div className="col-12 mb-3 mt-3 d-flex flex-column">
                    <div>Producto: <strong>{productProduction.name_product}</strong></div>
                    <div>Clave: <strong>{productProduction.key_product}</strong></div>
                    <div>
                        <Input
                            text="Cantidad"
                            classNameParent=""
                            placeholder="Cantidad"
                            className="text-center"
                            required
                            type="number"
                            min="1"
                            step="1"
                            value={productProduction.qty}
                            disabled={!isNaN(parseInt(row.p_id_document))}
                            onChange={e => {
                                if (isNaN(parseInt(e.currentTarget.value)) || parseInt(e.currentTarget.value) <= 0) {
                                    setProductProduction({
                                        ...productProduction,
                                        qty: 1
                                    })
                                } else {
                                    setProductProduction({
                                        ...productProduction,
                                        qty: e.currentTarget.value
                                    })
                                    setRow({
                                        ...row,
                                        p_details: row.p_details.map(r => {
                                            r.qty = r.qty_original * parseInt(e.currentTarget.value)
                                            return r
                                        })
                                    })
                                }
                            }}
                        />
                    </div>
                </div>}

                {isMass && isNaN(parseInt(row.p_id_document)) ? <div className="col-12 mb-2">
                    <TextArea
                        text="Listado de productos"
                        value={listProducts}
                        onChange={e => setListProducts(e.currentTarget.value)}
                        classNameParent="w-100 mb-2"
                        rows={5}
                        placeholder="Producto/cantidad separado por coma. Producto por línea:
                        ClaveProducto1, 5
                        ClaveProducto2, 10
                        "
                    />
                    <Button disabled={validateProducts} variant="info" size="sm" onClick={_ => {
                        if (!row.p_id_branch_office_origin) {
                            Helpers.toast.construct({ response: 'warning', message: 'Por favor, seleccionar Sucursal', toast })
                            return
                        }
                        if (!listProducts) {
                            Helpers.toast.construct({ response: 'warning', message: 'Por favor, agregar productos al listado', toast })
                            return
                        }
                        let existsError = false
                        let listProductsFormated = []
                        listProducts.split('\n').forEach(s => {
                            if (!existsError) {
                                let splitLine = s.split(',')
                                if (splitLine.length !== 2) {
                                    existsError = true
                                } else {
                                    if (isNaN(parseInt(splitLine[1]))) {
                                        existsError = true
                                    } else {
                                        if (!listProductsFormated.find(pf => pf.key_product === splitLine[0])) {
                                            listProductsFormated.push({
                                                key_product: splitLine[0],
                                                qty: parseInt(splitLine[1])
                                            })
                                        }
                                    }
                                }
                            }
                        })

                        if (existsError) {
                            Helpers.toast.construct({ response: 'warning', message: 'Por favor, revisar el formato del listado', toast })
                            return
                        }

                        setValidateProducts(true)
                        Controllers.product.get_product({
                            p_id_branch_office: row.p_id_branch_office_origin,
                        }).then(res => {
                            let newDetails = []

                            listProductsFormated.forEach(p => {
                                let existsProductKey = res.data.find(r => r.key_product.toLowerCase() === p.key_product.toLowerCase())
                                if (existsProductKey && !row.p_details.some(r => r.key_product.toLowerCase() === p.key_product.toLowerCase())) {
                                    newDetails.push({
                                        id_product: existsProductKey.id_product,
                                        key_product: existsProductKey.key_product,
                                        name_product: existsProductKey.name_product,
                                        lot: '',
                                        price: stockOut() ? existsProductKey.price_type_2 : '',
                                        qty: p.qty,
                                        date_expiration: ''
                                    })
                                }
                            })

                            if (stockOut()) {

                                let newDetailsLot = []
                                Promise.all(newDetails.map(n => {
                                    return Controllers.product.get_product_lot({
                                        p_id_product: n.id_product
                                    })
                                })).then(res => {

                                    res.forEach(r => {
                                        if (r.data.length > 0) {
                                            let findDet = newDetails.find(nd => parseInt(nd.id_product) === parseInt(r.data[0].id_product))
                                            if (findDet) {
                                                findDet.lots = r.data

                                                r.data.forEach(lt => {
                                                    if (findDet.date_expiration === '') {
                                                        findDet.lot = lt.lot
                                                        findDet.date_expiration = lt.date_expiration
                                                    } else if (lt.date_expiration < findDet.date_expiration) {
                                                        findDet.lot = lt.lot
                                                        findDet.date_expiration = lt.date_expiration
                                                    }
                                                })

                                                newDetailsLot.push(findDet)
                                            }
                                        }
                                    })

                                    setListProducts('')
                                    setIsMass(false)
                                    setRow({ ...row, p_details: [...row.p_details, ...newDetailsLot] })
                                })
                            } else {
                                setListProducts('')
                                setIsMass(false)
                                setRow({ ...row, p_details: [...row.p_details, ...newDetails] })
                            }
                        }).catch(req => Helpers.promise.catch({ req, toast }))
                            .finally(_ => {
                                setValidateProducts(false)
                            })
                    }}>
                        {validateProducts ? <i className="fa fa-circle-notch fa-spin"></i> : <><i className="fa fa-check"></i> Agregar Productos</>}
                    </Button>
                </div> : ''}

                {!existsStock.exists && existsStock.details.products.length > 0 ? <div className="col-12">
                    <div className="alert alert-warning d-flex flex-column">
                        <span>{existsStock.details.message}</span>
                        <span className="mt-2 mb-2">Detalle</span>

                        {React.Children.toArray(existsStock.details.products.map(p => <>
                            <span>Producto: <strong>{p.key_product}</strong></span>
                            <span>Cantidad Solicitada: <strong>{p.qty_request}</strong></span>
                            <span>Stock: <strong>{p.qty}</strong></span>
                        </>))}
                    </div>
                </div> : ''}
            </div>

            <div className="table-responsive col-12" id="table_details">
                <table className="table table-sm table-hover table-striped table-bordered">
                    <thead>
                        <tr>
                            {verified || ((parseInt(row.p_id_type_document) === 3 || parseInt(row.p_id_type_document) === 5 || parseInt(row.p_id_type_document) === 4) && !isNaN(parseInt(row.p_id_document))) ? <th>¿OK?</th> : ''}
                            {(DOC_TYPES_WITH_LOTS.includes(parseInt(row.p_id_type_document)) && isNaN(parseInt(row.p_id_document))) ? <th>Otro lote</th> : <th></th>}
                            <th>Clave</th>
                            <th>Descripción</th>
                            <th>Cantidad</th>
                            {parseInt(row.p_id_type_document) === 6 ? <></> : <th>Precio</th>}
                            {(parseInt(row.p_id_type_document) === 4 && (addDetails || parseInt(data.anulado) === 7 || parseInt(data.anulado) === 4 || parseInt(data.anulado) === 5 || parseInt(data.anulado) === 3 || parseInt(data.anulado) === 1)) || parseInt(row.p_id_type_document) <= 3 ? <>

                                <th style={{
                                    minWidth: 200
                                }}>Lote</th>
                                <th>Fecha Caducidad</th>
                            </> : <>
                                <th></th>
                                <th></th>
                            </>}
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {React.Children.toArray(row.p_details.map(r => {
                            let findLot = r?.lots?.find(l => l.lot === r.lot && l.date_expiration === r.date_expiration)

                            let typeUnit = '';
                            let finalQty = r.qty

                            if (parseInt(row.p_id_type_document) === 6) {
                                typeUnit = r.code_product_unit;
                                if (parseInt(r.id_product_unit) === 2 && finalQty >= 1000) {
                                    typeUnit = 'Kilos';
                                }

                                if (parseInt(r.has_conversion) === 1) {
                                    if (productProduction.qty <= r.qty_conversion) {
                                        finalQty = r.qty
                                    } else {
                                        let qty = parseFloat(finalQty) / parseFloat(r.qty_conversion)
                                        if (qty > parseInt(qty)) {
                                            qty = parseInt(qty) + 1
                                        }
                                        finalQty = qty
                                    }
                                }
                            }

                            return <tr>
                                {verified || ((parseInt(row.p_id_type_document) === 3 || parseInt(row.p_id_type_document) === 5 || parseInt(row.p_id_type_document) === 4) && !isNaN(parseInt(row.p_id_document))) ? <td className="text-center">
                                    <CheckBox
                                        id={'verified-' + r.id_product}
                                        classNameParent=""
                                        onChange={e => {
                                            setRow({
                                                ...row,
                                                p_details: row.p_details.map(rr => {
                                                    if (rr === r) {
                                                        rr.enabled = e.currentTarget.checked ? 1 : 0
                                                    }
                                                    return rr
                                                })
                                            })
                                        }}
                                        checked={parseInt(r.enabled) === 1}
                                        disabled={!verified}
                                    />
                                </td> : ''}
                                <td className="text-center">
                                    {(DOC_TYPES_WITH_LOTS.includes(parseInt(row.p_id_type_document)) && isNaN(parseInt(row.p_id_document))) && (
                                        <Button size="xs" variant="secondary" onClick={() => {
                                            // Clonar la fila actual como nuevo detalle (otro lote)
                                            const clone = { ...r }
                                            // Vaciar datos de lote/cantidad para forzar selección
                                            clone.lot = ''
                                            clone.date_expiration = ''
                                            clone.qty = ''
                                            // mantener price si aplica
                                            setRow({ ...row, p_details: [...row.p_details, clone] })
                                        }}>
                                            <i className="fa fa-plus"></i>
                                        </Button>
                                    )}
                                </td>
                                <td>{r.key_product}</td>
                                <td>{r.name_product}</td>
                                <td>
                                    <Input
                                        className="text-center"
                                        required
                                        type="number"
                                        min="1"
                                        step="1"
                                        {...(parseInt(row.p_id_type_document) === 1 ? {} : {
                                            max: findLot?.exists_current_qty_product
                                        })}
                                        value={!isNaN(parseInt(finalQty)) ? finalQty : ''}
                                        onChange={e => {
                                            setRow({
                                                ...row,
                                                p_details: row.p_details.map(rr => {
                                                    if (rr === r) {
                                                        rr.qty = e.currentTarget.value
                                                    }
                                                    return rr
                                                })
                                            })
                                        }}
                                        style={{
                                            minWidth: '100px'
                                        }}
                                        disabled={!viewSubmit || parseInt(row.p_id_type_document) === 6}
                                    />
                                    {parseInt(row.p_id_type_document) === 6 && <div>
                                        {r?.lot && JSON.parse(r?.lot).map(lt => {
                                            return <div className='text-muted mb-2'>
                                                <div><small>Lote: <strong>{lt.lot}</strong></small></div>
                                                <div><small>Fecha Exp: {lt.date_expiration}</small></div>
                                                <div><small>Cant: {lt.qty}</small></div>
                                            </div>
                                        })}
                                    </div>}
                                </td>
                                {parseInt(row.p_id_type_document) === 6 ? <td>
                                    {parseInt(row.p_id_type_document) === 6 && <div className='align-self-center'>
                                        {parseInt(r.id_product_unit) === 2 ? parseFloat(parseFloat(!isNaN(parseInt(finalQty)) ? finalQty : 0) / 1000).toFixed(4) : finalQty} {typeUnit}
                                    </div>}
                                </td> : <td>
                                    <Input
                                        className="text-center"
                                        required
                                        type="number"
                                        min="0.001"
                                        step="0.001"
                                        value={!isNaN(parseInt(r.price)) ? r.price : ''}
                                        onChange={e => {
                                            setRow({
                                                ...row,
                                                p_details: row.p_details.map(rr => {
                                                    if (rr === r) {
                                                        rr.price = e.currentTarget.value
                                                    }
                                                    return rr
                                                })
                                            })
                                        }}
                                        style={{
                                            minWidth: '100px'
                                        }}
                                        disabled={!viewSubmit}
                                    />
                                </td>}
                                {(parseInt(row.p_id_type_document) === 4 && (addDetails || parseInt(data.anulado) === 7 || parseInt(data.anulado) === 4 || parseInt(data.anulado) === 5 || parseInt(data.anulado) === 3 || parseInt(data.anulado) === 1)) || parseInt(row.p_id_type_document) <= 3 ? <>
                                    <td>
                                        {!viewSubmit ? <>
                                            <span>{r.lot}</span>
                                        </> : parseInt(row.p_id_type_document) === 1 || parseInt(row.p_id_type_document) === 4 ? <Input
                                            className="text-center"
                                            required
                                            value={r.lot}
                                            onChange={e => {
                                                setRow({
                                                    ...row,
                                                    p_details: row.p_details.map(rr => {
                                                        if (rr === r) {
                                                            rr.lot = e.currentTarget.value
                                                        }
                                                        return rr
                                                    })
                                                })
                                            }}
                                            style={{
                                                minWidth: '100px'
                                            }}
                                            disabled={!viewSubmit && !addDetails}
                                        /> : <>
                                            <Select
                                                options={r?.lots?.map(l => {
                                                    return {
                                                        label: l.lot + ` (${l.date_expiration})`,
                                                        value: l.lot,
                                                        date_expiration: l.date_expiration
                                                    }
                                                })}
                                                value={findLot ? {
                                                    label: findLot.lot + ` (${findLot.date_expiration})`,
                                                    value: findLot.lot,
                                                    date_expiration: findLot.date_expiration
                                                } : ''}
                                                onChange={e => {
                                                    setRow({
                                                        ...row,
                                                        p_details: row.p_details.map(rr => {
                                                            if (rr === r) {
                                                                rr.lot = e.value
                                                                rr.date_expiration = e.date_expiration
                                                            }
                                                            return rr
                                                        })
                                                    })
                                                }}
                                                disabled={!viewSubmit}
                                            />
                                        </>}
                                    </td>
                                    <td>
                                        {!viewSubmit ? <>
                                            <span>{r.date_expiration}</span>
                                        </> : <>
                                            <Input
                                                type="date"
                                                className="text-center"
                                                required
                                                value={parseInt(row.p_id_type_document) === 1 || parseInt(row.p_id_type_document) === 4 ? r.date_expiration :
                                                    (findLot ? findLot.date_expiration : '')}
                                                onChange={e => {
                                                    setRow({
                                                        ...row,
                                                        p_details: row.p_details.map(rr => {
                                                            if (rr === r) {
                                                                rr.date_expiration = e.currentTarget.value
                                                            }
                                                            return rr
                                                        })
                                                    })
                                                }}
                                                style={{
                                                    minWidth: '100px'
                                                }}
                                                disabled={(parseInt(row.p_id_type_document) !== 1 && parseInt(row.p_id_type_document) !== 4) || !viewSubmit && !addDetails}
                                            />
                                        </>}
                                    </td>
                                </> : <>
                                    <td></td>
                                    <td></td>
                                </>}
                                <td>
                                    {parseInt(row.p_id_type_document) === 6 ? <></> : <>
                                        {isNaN(parseInt(row.p_id_document)) ? <Button size="xs" variant="danger" onClick={() => {
                                            const idx = row.p_details.indexOf(r)
                                            if (idx > -1) {
                                                const next = [...row.p_details]
                                                next.splice(idx, 1)
                                                setRow({ ...row, p_details: next })
                                            }
                                        }}>
                                            <i className="fa fa-trash"></i>
                                        </Button> : ''}
                                    </>}
                                </td>
                            </tr>
                        }))}
                        <tr>
                            <td></td>
                            <td align="center">Total Piezas</td>
                            <td align="center">{getSubtotal().totalPiezas}</td>
                            <td>
                                {parseInt(row.p_id_type_document) === 6 && <div className='align-self-center'>
                                    {/* {
                                        row.p_details.length > 0 && parseInt(row.p_details[0].id_product_unit) === 2 ? parseFloat(getSubtotal().totalPiezas / 1000).toFixed(4) :
                                            getSubtotal().totalPiezas
                                    } {totalUnit()} */}
                                    {renderPiezas}
                                </div>
                                }
                            </td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                        {parseInt(row.p_id_type_document) === 6 ? <></> : <>
                            <tr>
                                {verified || ((parseInt(row.p_id_type_document) === 3 || parseInt(row.p_id_type_document) === 5 || parseInt(row.p_id_type_document) === 4) && !isNaN(parseInt(row.p_id_document))) ? <td></td> : ''}
                                <td></td>
                                <td></td>
                                <td></td>
                                <td align="center">Subtotal</td>
                                <td align="center">{getSubtotal().subtotal}</td>
                                <td></td>
                                <td></td>
                            </tr>
                            <tr>
                                {verified || ((parseInt(row.p_id_type_document) === 3 || parseInt(row.p_id_type_document) === 5 || parseInt(row.p_id_type_document) === 4) && !isNaN(parseInt(row.p_id_document))) ? <td></td> : ''}
                                <td></td>
                                <td></td>
                                <td></td>
                                <td align="center">IVA</td>
                                <td align="center">{getSubtotal().iva}</td>
                                <td></td>
                                <td></td>
                            </tr>
                            <tr>
                                {verified || ((parseInt(row.p_id_type_document) === 3 || parseInt(row.p_id_type_document) === 5 || parseInt(row.p_id_type_document) === 4) && !isNaN(parseInt(row.p_id_document))) ? <td></td> : ''}
                                <td></td>
                                <td></td>
                                <td></td>
                                <td align="center">Total</td>
                                <td align="center">{getSubtotal().total}</td>
                                <td></td>
                                <td></td>
                            </tr>
                        </>}
                    </tbody>
                </table>
            </div>
        </FormCustom>

        {!isNaN(parseInt(row.p_id_document)) && <div className='mt-2'>
            <Button size="sm" variant='danger mb-2' onClick={_ => {
                if (parseInt(row.p_id_type_document) === 6) {
                    Helpers.print.construct({
                        selector: '#document_header',
                        title: 'Documento',
                        addHtml: `<div style="width: 100%">
                            <hr />
                            <div><strong>Firmas</strong></div>
                            <br /><br /><br /><br />
            
                            <div>
                                <div style="float: left; margin-right: 50px">
                                    <div><strong>___________________________________</strong></div>
                                    <div><strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Solicitud de Materia Prima</strong></div>
                                </div>
                                <div style="float:left">
                                    <div><strong>___________________________________</strong></div>
                                    <div><strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Liberación de Materia Prima</strong></div>
                                </div>
                            </div>
            
                            <br /><br /><br /><br /><br /><br />
            
                            <div>
                                <div style="float: left; margin-right: 50px">
                                    <div><strong>___________________________________</strong></div>
                                    <div><strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Térmio de Producción</strong></div>
                                    <br />
                                </div>
                                <div style="float:left">
                                    <div><strong>___________________________________</strong></div>
                                    <div><strong>Recepción de Producto Terminado</strong></div>
                                    <br />
                                </div>
                            </div>
                        </div>
                        `
                    })
                } else {
                    Helpers.print.construct({
                        selector: '#frm_document_content',
                        title: 'Documento',
                    })
                }
            }}>
                <i className="fa fa-print mr-2"></i>
                <span>Imprimir Documento</span>
            </Button>

            {parseInt(row.p_id_type_document) === 6 && <Button size="sm" variant='dark ml-4 mb-2' onClick={_ => {
                Helpers.print.construct({
                    selector: '#table_details',
                    title: 'Documento'
                })
            }}>
                <i className="fa fa-print mr-2"></i>
                <span>Imprimir Materia Prima</span>
            </Button>}
        </div>}

        {!isNaN(parseInt(row.p_id_document)) && data.observation_confirm ? <>
            <div>
                <strong>Observación</strong>
                <p className="">{data.observation_confirm}</p>
            </div>
        </> : ''}

        {!isNaN(parseInt(row.p_id_document)) && data.date_production ? <>
            <div className="mt-4 mb-4">
                <span>Fecha estimada de producción: </span>
                <strong className="">{data.date_production}</strong>
            </div>
        </> : ''}

        {verified ? <>
            <div className="d-flex flex-column flex-lg-row">
                <CheckBox
                    id="approve"
                    text="Aprobar"
                    classNameParent="mr-4"
                    onChange={_ => setStatus({ ...status, p_anulado: 3 })}
                    checked={parseInt(status.p_anulado) === 3}
                    disabled={!enabledChecks}
                />
                <CheckBox
                    id="approve-observation"
                    text="Aprobar con Observación"
                    classNameParent="mr-4"
                    onChange={_ => setStatus({ ...status, p_anulado: 4 })}
                    checked={parseInt(status.p_anulado) === 4}
                    disabled={!enabledChecks}
                />
                <CheckBox
                    id="rejected"
                    text="Rechazar"
                    classNameParent="mr-4"
                    onChange={_ => setStatus({ ...status, p_anulado: 5 })}
                    checked={parseInt(status.p_anulado) === 5}
                    disabled={!enabledChecks}
                />
            </div>
            <TextArea
                placeholder="Ingresar observación"
                text="Observación"
                value={status.p_observation_confirm}
                classNameParent="w-100 mt-2 mb-2"
                rows={5}
                onChange={e => setStatus({ ...status, p_observation_confirm: e.currentTarget.value })}
            />
            <Button disabled={loadStatus} className="btn btn-success" size="sm" onClick={_ => {
                if (!status.p_anulado) {
                    Helpers.toast.construct({ response: 'warning', message: 'Seleccionar aprobación/rechazo', toast })
                    return
                }

                setLoadStatus(true)
                Controllers.document.document_approve_rejected({
                    p_id_document: row.p_id_document,
                    p_anulado: status.p_anulado,
                    p_observation_confirm: status.p_observation_confirm,
                    p_details: row.p_details.filter(p => parseInt(p.enabled) === 0).map(p => {
                        return {
                            id_product: p.id_product,
                            enabled: p.enabled,
                            lot: p.lot,
                        }
                    })
                }).then(res => {
                    Helpers.toast.construct({ ...res, toast })
                    setLoadStatus(false)

                    if (res.response === 'success') {
                        submitStatus();
                    } else {
                        setExistsStock({
                            exists: res.response === 'success',
                            details: {
                                message: res.message,
                                products: res.data
                            }
                        })
                    }
                }).catch(() => {
                    setExistsStock({
                        exists: false,
                        details: {
                            message: 'No se ha podido verificar stock.',
                            products: []
                        }
                    })
                    setLoadStatus(false)
                })
            }}>
                {!loadStatus ? <><i className="fa fa-check"></i> Actualizar Documento</> : <i className="fa fa-circle-notch fa-spin"></i>}
            </Button>
        </> : ''}

        <ProductList showModal={modalProducts} viewPack={false} hideModal={handleHideModalProducts} nameSingle="Producto" namePlural="Productos" separator="el" added={stockOut() ? [] : row.p_details} idBranchOffice={row.p_id_branch_office_origin} addItem={({ idProduct, keyProduct, nameProduct, priceProduct, priceProductType2 }) => {
            if (parseInt(row.p_id_type_document) === 6) {
                setProductProduction({
                    id_product: idProduct,
                    key_product: keyProduct,
                    name_product: nameProduct,
                    qty: 1,
                })
                Controllers.product_production.get_product_production({
                    p_id_product: idProduct
                }).then(res => {
                    setRow({
                        ...row,
                        p_details: res.data.map(p => {
                            return {
                                id_product: p.id_production,
                                key_product: p.key_product,
                                name_product: p.name_product,
                                lot: '',
                                price: '',
                                qty: p.qty,
                                qty_original: p.qty,
                                date_expiration: '',
                                id_product_unit: p.id_product_unit,
                                code_product_unit: p.code_product_unit,
                                qty_conversion: p.qty_conversion,
                                new_qty: p.new_qty,
                                new_id_product_unit: p.new_id_product_unit,
                                has_conversion: p.has_conversion,
                                new_code_product_unit: p.new_code_product_unit,
                            }
                        })
                    })
                })
            } else {
                let newDet = {
                    id_product: idProduct,
                    key_product: keyProduct,
                    name_product: nameProduct,
                    lot: '',
                    price: stockOut() ? priceProductType2 : '',
                    qty: '',
                    date_expiration: ''
                }

                if (stockOut()) {
                    Controllers.product.get_product_lot({
                        p_id_product: idProduct
                    }).then(res => {
                        if (res.data.length === 0) {
                            Helpers.toast.construct({ response: 'warning', message: 'No hay lote/stock disponible.', toast })
                            return
                        }

                        res.data.forEach(lt => {
                            if (newDet.date_expiration === '') {
                                newDet.lot = lt.lot
                                newDet.date_expiration = lt.date_expiration
                            } else if (lt.date_expiration < newDet.date_expiration) {
                                newDet.lot = lt.lot
                                newDet.date_expiration = lt.date_expiration
                            }
                        })

                        newDet = {
                            ...newDet,
                            lots: res.data
                        }
                        setRow({ ...row, p_details: [...row.p_details, newDet] })
                    })
                } else {
                    setRow({ ...row, p_details: [...row.p_details, newDet] })
                }
            }
        }} />
    </ReactPlaceholder>
}

DocumentForm.defaultProps = {
    data: {
        id_document: '',
        number_invoice_doc: '',
        number_lot_doc: '',
        code_period: '',
        id_period: '',
        id_type_document: '',
        observation_doc: '',
        id_branch_office_origin: '',
        id_branch_office_destination: '',
        date_doc: Helpers.date.get({ 'format': '%Y-%m-%d' }),
        details: [],
        id_product: '',
        key_product: '',
        name_product: '',
        qty_product: '',
        observation_materia_prima: '',
        date_free_materia_prima: '',
        date_approve_production: '',
        date_approve_recepcion: '',
    },
    onSubmit: () => { },
    loadSubmit: false,
    viewSubmit: true,
    verified: false,
    submitStatus: _ => { },
    addDetails: false,
}

export default DocumentForm;